import { createSlice } from "@reduxjs/toolkit";
import { getMyAssigments, getWorkspaceAssigments } from "./actions";
import { Assigments } from "store/assignments/types";

export type AssigmentsState = {
  error: any;
  loading: boolean;
  myAssigments: Assigments;
  workspaceAssigments: Assigments;
};

const initialState: AssigmentsState = {
  error: false,
  loading: false,
  myAssigments: {
    tasks_count: 0,
    votings_count: 0,
    meetings_count: 0,
  },
  workspaceAssigments: {
    tasks_count: 0,
    votings_count: 0,
    meetings_count: 0,
  },
};

export const assigmentsSlice = createSlice({
  name: "assigments",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    //GET MY ASSIGMENTS
    builder.addCase(getMyAssigments.rejected, (state, action) => {
      state.loading = false;
      state.error = action.payload;
    });
    builder.addCase(getMyAssigments.pending, (state) => {
      state.loading = true;
      state.error = false;
    });
    builder.addCase(getMyAssigments.fulfilled, (state, action) => {
      state.loading = false;
      state.error = false;
      state.myAssigments = action.payload;
    });

    //GET WORKSPACE ASSIGMENTS
    builder.addCase(getWorkspaceAssigments.rejected, (state, action) => {
      state.loading = false;
      state.error = action.payload;
    });
    builder.addCase(getWorkspaceAssigments.pending, (state) => {
      state.loading = true;
      state.error = false;
    });
    builder.addCase(getWorkspaceAssigments.fulfilled, (state, action) => {
      state.loading = false;
      state.error = false;
      state.workspaceAssigments = action.payload;
    });
  },
});

export default assigmentsSlice.reducer;
